import * as React from 'react';
import * as PropTypes from 'prop-types';
import {translate, Interpolate, InjectedTranslateProps} from 'react-i18next';
import {FedopsLogger} from '../../utils/fedops-logger';
import {startTrackingFolds, stopTrackingFolds} from '../../utils/track-folds';
import LinkMore from '../LinkMore';
import Products from '../Products';
import Features from '../Features';
import IntroText from '../IntroText';
import Marketing from '../Marketing';
import FreeSite from '../FreeSite';
import * as s from './App.scss';
import {PrerenderReporter} from '../../utils/prerender-reporter';
import {reportClick} from '../../utils/bi';
import experiments from '../../utils/experiments';
import {biLogger, getOrigin, HP_VERSION} from '../../utils/bi-logger';
import {setLang} from '../../utils/ctaLinks';
import {i18n as I18n} from 'i18next';
import {ExperimentsBag} from 'wix-experiments';

interface AppProps extends InjectedTranslateProps {
  staticsBaseUrl: string;
  fedopsLogger?: FedopsLogger;
  i18n?: I18n;
  experiments: ExperimentsBag;
}

class App extends React.Component<AppProps> {
  private prerenderReporter: PrerenderReporter = new PrerenderReporter();
  static propTypes = {
    t: PropTypes.func
  };
  private componentUnmounted: boolean = false;

  constructor(props: AppProps) {
    super(props);
    setLang(props.i18n.language);
    experiments.add(props.experiments);
  }

  componentDidMount() {
    experiments.load('marketing-homepage').then(() => !this.componentUnmounted && this.forceUpdate());

    startTrackingFolds({
      timeOnFold: 3000,
      folds: document.querySelectorAll('.page-fold')
    });
    this.prerenderReporter.start();
    biLogger.getLogger('hp').hpFinishLoading({
      delta: Date.now() - window['wixHpLoadTime'],
      origin: getOrigin(),
      version: HP_VERSION
    });
    this.props.fedopsLogger && this.props.fedopsLogger.appLoaded();
  }

  componentWillUnmount() {
    stopTrackingFolds();
    this.componentUnmounted = true;
    this.prerenderReporter.stop();
  }

  render() {
    const {staticsBaseUrl, t} = this.props;
    const imgFolder = 'assets/images/blue-hero';

    return (
      <div>
        <div className={`page-fold ${s.hero}`} data-foldname="hero" data-foldnum="1">
          <div className={s.heroWrap}>
            <picture>
              <source media="(min-width: 1441px)" srcSet={`${staticsBaseUrl}${imgFolder}/homepage-hero-xlarge.jpg`}/>
              <source media="(min-width: 1024px)" srcSet={`${staticsBaseUrl}${imgFolder}/homepage-hero-large.jpg`}/>
              <source media="(min-width: 560px)" srcSet={`${staticsBaseUrl}${imgFolder}/homepage-hero-mobile-landscape-v2.jpg`}/>
              <source srcSet={`${staticsBaseUrl}${imgFolder}/homepage-hero-mobile-v2.jpg`}/>
              <img src={`${staticsBaseUrl}${imgFolder}/homepage-hero-xlarge.jpg`} alt={t('seo_hero_alt')}/>
            </picture>
            <div className={s.heroContent}>
              <div>
                <Interpolate parent="h1" i18nKey="hero.title" lineBreak={<br/>} lineBreakMobile={<span className={s.lineBreakMobile}></span>} />
                <LinkMore
                  className={s.linkMore}
                  theme="button"
                  data-hook="hero-get-started"
                  data-foldname="hero"
                  onClick={reportClick}
                >
                  {t('hero.getStarted')}
                </LinkMore>
              </div>
            </div>
          </div>
        </div>
        <IntroText/>
        <Products staticsBaseUrl={staticsBaseUrl}/>
        <Features staticsBaseUrl={staticsBaseUrl}/>
        <Marketing staticsBaseUrl={staticsBaseUrl}/>
        <FreeSite/>
      </div>
    );
  }
}

export default translate()(App);
